export default {
    documents: {
        title: '文檔',
        loading: '載入中...',
        retry: '重試',
        noDocuments: '暫無文檔',
        createFirst: '建立你的第一個文檔',

        // Document types
        types: {
            disclosure: '技術交底書',
            patent_draft: '專利文稿',
            prosecution: '答覆文件',
            patent_claim: '權利要求',
            specification: '說明書',
            rejection_comparison: '駁回對比',
            technical_doc: '技術文檔',
            other: '其他',
        },

        // Time formatting
        time: {
            today: '今天',
            yesterday: '昨天',
            daysAgo: '{count} 天前',
        },

        // Actions
        actions: {
            delete: '刪除',
            edit: '編輯',
            download: '下載',
            open: '打開',
        },

        // Rename dialog
        rename: {
            title: '修改文檔名稱',
            confirm: '保存',
            cancel: '取消',
            inputErrorMessage: '請輸入文檔名稱',
        },

        // Content preview
        preview: {
            noContent: '暫無內容',
            wordCount: '{count} 字',
        },

        // Delete confirmation
        deleteConfirm: {
            title: '刪除文檔',
            message: '確定要刪除"{title}"嗎？',
            confirm: '刪除',
            cancel: '取消',
        },

        // Messages
        deleteSuccess: '文檔刪除成功',
        renameSuccess: '文檔名稱修改成功',
        downloadSuccess: '文檔下載成功',

        // Errors
        errors: {
            loadFailed: '載入文檔失敗',
            openFailed: '打開文檔失敗',
            deleteFailed: '刪除文檔失敗',
            renameFailed: '修改文檔名稱失敗',
            downloadFailed: '下載文檔失敗',
        },
    },
};
